import type { IOrganization } from '@/api/routes/orgs/types';

enum DefaultOrgs {
  YANDEX = 'яндекс',
  RIM = 'рим',
}

// eslint-disable-next-line arrow-body-style
export const getDefaultFilterOrgs = (orgs: IOrganization[]) => {
  return orgs.filter(({ name }) => name.toLowerCase() === DefaultOrgs.YANDEX || name.toLowerCase() === DefaultOrgs.RIM)
    ?.map(({ id }) => id);
};
